module.exports = __webpack_public_path__ + "img/congress of sages.115167c9.png";